import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from './Select.jsx';

export default function SelectManagers(props) {
	let {
		parentFunction,
		selectedItems,
		label = '',
		multiple = true,
		items = null
	} = props;
	
	const [selectManagersItems, setSelectManagersItems] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [hasGroups, setHasGroups] = useState(false);
	
	const fetchData = () => {
		let url = ENV.base_lang_url + "myspace/providers//ajaxGetter/get_select_managers_items";
		axios.get(url, {
			headers: {}
		}).then(result => {
			let data = result.data ?? [];
			if (data.length > 0) {
				setSelectManagersItems(data);
				for(let i in data){
					if ( data[i].isGroup ) {
						setHasGroups(true);
						break;
					}
				}
				setIsLoading(false)
			}
			else {
				setIsLoading(false)
			}
		});
	}

	useEffect(() => {
		if(!items) {
			fetchData();
		}
	}, []);

	useEffect(() => {
		if(items) {
			setSelectManagersItems(items);
			setIsLoading(false)
			setHasGroups(false)
		}
	}, [items]);
	
	return (
		<Select
			parentFunction={parentFunction}
			slug={'managers'}
			label={label}
			placeHolder={label == '' ? 'manager'.trad() : null}
			items={selectManagersItems}
			selectedItems={selectedItems}
			autoTrad={false}
			multiple={multiple}
			limitTags={1}
			checkbox={multiple}
			isLoading={isLoading}
			hasGroups={hasGroups}
		/>
	);
}